var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert my-2",attrs:{"dense":true,"outlined":true,"transition":"scale-transition","dismissible":""},on:{"input":_vm.onInput}},[_c('span',[_vm._v(_vm._s(_vm.value.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }